export enum PromotionType {
  PERCENTAGE = "PERCENTAGE",
  FIXED = "FIXED",
  SHIPPING_FEES = "SHIPPING_FEES",
  BUY_X_GET_Y = "BUY_X_GET_Y",
}
